/** Legacy PHP symbol: creature_exempt_from_geometry_squeeze. */
export function creatureExemptFromGeometrySqueeze(_creature: unknown, _encounter: unknown): boolean { return false; }
